var _clipPath;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    style: {
      fill: "none"
    }
  }), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.412-1.402h512v512h-512z",
    style: {
      fill: "#f93",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.412 169.264h512v341.333h-512z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.412 339.931h512v170.667h-512z",
    style: {
      fill: "#128807",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.239,
    cy: 254.598,
    r: 68.267,
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.239,
    cy: 254.598,
    r: 59.733,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256.239,
    cy: 254.598,
    r: 11.947,
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.864 259.327a3.072 3.072 0 1 1-.803 6.09 3.072 3.072 0 0 1 .803-6.09",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.239 314.331 2.048-35.84-2.048-17.067-2.048 17.067z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.608 274.598a3.073 3.073 0 1 1-2.353 5.677 3.073 3.073 0 0 1 2.353-5.677",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.778 312.296 11.255-34.089 2.439-17.015-6.396 15.955z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.511 288.506a3.073 3.073 0 0 1 .567 4.307 3.073 3.073 0 0 1-4.307.567 3.072 3.072 0 0 1 3.74-4.874",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.372 306.328 19.694-30.014 6.759-15.804-10.307 13.756z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.056 300.103a3.073 3.073 0 0 1-.567 4.307 3.073 3.073 0 0 1-4.307-.567 3.073 3.073 0 0 1 .567-4.307 3.073 3.073 0 0 1 4.307.567",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.001 296.836 26.791-23.895 10.619-13.516-13.516 10.62z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.956 308.599a3.072 3.072 0 1 1-5.676 2.35 3.072 3.072 0 0 1 5.676-2.35",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.508 284.464 32.062-16.146 13.756-10.307-15.804 6.76z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.103 313.415a3.073 3.073 0 1 1-3.447-2.645 3.074 3.074 0 0 1 3.447 2.645",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.541 270.058 35.148-7.298 15.956-6.395-17.016 2.439z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.51 314.223a3.075 3.075 0 0 1-3.447 2.645 3.075 3.075 0 0 1-2.645-3.447 3.075 3.075 0 0 1 3.447-2.645 3.074 3.074 0 0 1 2.645 3.447",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.505 254.598 35.84 2.048 17.067-2.048-17.067-2.048z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.239 310.967a3.074 3.074 0 0 1-5.677-2.351 3.072 3.072 0 0 1 5.677 2.351",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.541 239.138 34.088 11.254 17.016 2.439-15.956-6.396z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.331 303.87a3.073 3.073 0 1 1-.567-4.307 3.073 3.073 0 0 1 .567 4.307",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m204.508 224.731 30.014 19.694 15.804 6.759-13.756-10.307z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.733 293.415a3.073 3.073 0 0 1-4.307-.567 3.073 3.073 0 0 1 4.875-3.74 3.073 3.073 0 0 1-.568 4.307",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.001 212.36 23.894 26.791 13.516 10.62-10.619-13.517z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.237 280.315a3.072 3.072 0 1 1-2.35-5.677 3.072 3.072 0 0 1 2.35 5.677",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.372 202.867 16.146 32.063 10.307 13.756-6.759-15.804z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.421 265.462a3.072 3.072 0 1 1-.8-6.092 3.072 3.072 0 0 1 .8 6.092",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m240.778 196.9 7.298 35.149 6.396 15.955-2.439-17.015z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.613 249.869a3.073 3.073 0 1 1 .804-6.092 3.073 3.073 0 0 1-.804 6.092",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.239 194.864-2.048 35.84 2.048 17.067 2.048-17.067z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.869 234.598a3.075 3.075 0 0 1-1.663-4.014 3.072 3.072 0 1 1 1.663 4.014",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.699 196.9-11.255 34.089-2.439 17.015 6.396-15.955z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.966 220.69a3.072 3.072 0 1 1 3.74-4.872 3.072 3.072 0 0 1-3.74 4.872",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.105 202.867-19.693 30.015-6.76 15.804 10.307-13.756z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.421 209.093a3.073 3.073 0 1 1 4.307.567 3.073 3.073 0 0 1-4.307-.567",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.476 212.36-26.79 23.894-10.62 13.517 13.516-10.62z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.521 200.597a3.073 3.073 0 0 1 5.677-2.352 3.075 3.075 0 0 1-1.663 4.014 3.074 3.074 0 0 1-4.014-1.662",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.969 224.731-32.062 16.146-13.756 10.307 15.804-6.759z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.374 195.78a3.073 3.073 0 0 1 6.092-.802 3.074 3.074 0 0 1-2.645 3.447 3.074 3.074 0 0 1-3.447-2.645",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.937 239.138-35.149 7.297-15.955 6.396 17.015-2.439z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.967 194.973a3.075 3.075 0 0 1 3.447-2.645 3.074 3.074 0 0 1 2.645 3.447 3.073 3.073 0 0 1-6.092-.802",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m315.972 254.598-35.84-2.048-17.067 2.048 17.067 2.048z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.238 198.228a3.073 3.073 0 0 1 5.677 2.351 3.074 3.074 0 0 1-5.677-2.351",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313.937 270.058-34.089-11.254-17.015-2.439 15.955 6.395z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.146 205.325a3.075 3.075 0 0 1 4.308-.567 3.074 3.074 0 0 1 .567 4.308 3.074 3.074 0 0 1-4.308.567 3.075 3.075 0 0 1-.567-4.308",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m307.969 284.464-30.014-19.693-15.804-6.76 13.756 10.307z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.744 215.78a3.073 3.073 0 0 1 3.74 4.875 3.073 3.073 0 0 1-3.74-4.875",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m298.476 296.836-23.894-26.791-13.516-10.62 10.62 13.516z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.24 228.88a3.075 3.075 0 0 1 4.014 1.663 3.074 3.074 0 1 1-4.014-1.663",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m286.105 306.328-16.146-32.062-10.307-13.756 6.76 15.804z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.056 243.733a3.075 3.075 0 0 1 3.447 2.645 3.075 3.075 0 0 1-2.645 3.447 3.074 3.074 0 0 1-3.447-2.645 3.075 3.075 0 0 1 2.645-3.447",
    style: {
      fill: "#008"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m271.699 312.296-7.298-35.149-6.396-15.955 2.439 17.015z",
    style: {
      fill: "#008",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHi);
export default __webpack_public_path__ + "static/media/hi.b5ed7c935bbedf1167c7e42f2e84a277.svg";
export { ForwardRef as ReactComponent };